import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { FormControl, FormGroup } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import {
  CalendarA11y,
  CalendarCommonModule,
  CalendarDateFormatter,
  CalendarEvent,
  CalendarEventTitleFormatter,
  CalendarUtils,
  CalendarWeekModule,
  DateAdapter
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { filter } from 'rxjs/operators';
import { BookingItemNamePipe } from 'src/app/shared/pipes/booking-item-name.pipe';
import { MetaData } from '../../models/combined-calendar';
import { ProductService } from '../../shared';
import { ItemDialogComponent } from '../../shared/dialogs/item-dialog/item-dialog.component';
import { NewTransactionDialogComponent } from '../../shared/dialogs/new-transaction-dialog/new-transaction-dialog.component';
import { DashboardService } from '../../shared/services/dashboard.service';
import { ProductCategoryService } from '../../shared/services/product-category.service';
import { CalendarFilterComponent } from './calendar-filter/calendar-filter.component';
import { QuickFilterComponent } from './quick-filter/quick-filter.component';
import { CombinedCalendarStore } from './store/combined-calendar-store';

@Component({
  selector: 'app-combined-calendar',
  templateUrl: './combined-calendar.component.html',
  styleUrls: ['./combined-calendar.component.css'],
  providers: [
    CombinedCalendarStore,
    ProductService,
    ProductCategoryService,
    DashboardService,
    BookingItemNamePipe,
    CalendarUtils,
    {
      provide: DateAdapter,
      useFactory: adapterFactory
    },
    CalendarA11y,
    CalendarDateFormatter,
    CalendarEventTitleFormatter
  ],
  standalone: true,
  imports: [
    MatDrawerContainer,
    MatDrawer,
    CalendarFilterComponent,
    FlexModule,
    QuickFilterComponent,
    MatButton,
    MatIconButton,
    MatIcon,
    CalendarCommonModule,
    CalendarWeekModule,
    AsyncPipe
  ]
})
export class CombinedCalendarComponent {
  calendarDate$ = this.combinedCalendarStore.calendarDate$;
  events$ = this.combinedCalendarStore.filteredEvents$;

  quickFilterForm = new FormGroup({
    available: new FormControl(true),
    hires: new FormControl(true),
    bookings: new FormControl(true)
  });

  constructor(
    private readonly combinedCalendarStore: CombinedCalendarStore,
    public dialog: MatDialog,
    private router: Router
  ) {}

  updateCalendarDate(change: 1 | 0 | -1) {
    if (change === 0) {
      this.combinedCalendarStore.viewCurrentWeek();
      return;
    }
    this.combinedCalendarStore.updateCalendarDate(change);
  }

  clicked(click: { event: CalendarEvent<MetaData<any>> }) {
    const id = click.event.meta.parent_id;
    switch (click.event.meta.type) {
      case 'bookingItem':
        this.router.navigate(['bookings/view', id]);
        break;
      case 'hireItem':
        this.router.navigate(['docket', id]);
        break;
      case 'product':
        this.router.navigate(['product', id], {
          queryParams: { type: 'hire' }
        });
        break;
      case 'available':
        this.openItemDialog(click);
    }
  }

  private openItemDialog(click: { event: CalendarEvent<MetaData<any>> }) {
    this.dialog
      .open(ItemDialogComponent, {
        data: {
          item: {
            id: click.event.meta.item.id,
            product_id: click.event.meta.item.product_id
          }
        },
        width: '70%'
      })
      .afterClosed()
      .pipe(filter((doHire) => doHire))
      .subscribe({
        next: () => this.placeItemOnHire(click.event.meta.item.id)
      });
  }

  private placeItemOnHire(itemId: number) {
    this.dialog.open(NewTransactionDialogComponent, {
      data: { itemId, transactionProductType: 'hire' }
    });
  }
}
